import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Collaborator, ICollaborator, ICollaboratorPayload } from '../Collaborator.ts';
import { useParams } from 'react-router';
import { CollaboratorApi } from '../../../apis/CollaboratorApi/CollaboratorApi.ts';

export function usePutCollaborator() {
    const queryClient = useQueryClient();
    const { id } = useParams<{ id: string }>();

    return useMutation({
        mutationKey: [QueryKeys.collaborator, QueryKeys.collaborators],

        mutationFn: async (variables: ICollaboratorPayload) => {
            if (!id) 
                throw new Error('Missing collaborator ID for update.');
            
            await CollaboratorApi.putCollaborator(id!, variables);
            const collaborator = new Collaborator({ ...(variables as ICollaborator), id: Number(id) });
            return collaborator;
        },
        onSuccess: async (data: ICollaborator) => {
            queryClient.setQueryData<ICollaborator>([QueryKeys.collaborator, id], (prev) => {
                return data || prev;
            });
            queryClient.setQueryData<ICollaborator[]>([QueryKeys.collaborators], (prev) => {
                return (
                    prev?.map((collaborator) =>
                        collaborator.id == data.id ? { ...collaborator, ...data } : collaborator,
                    ) || []
                );
            });
        },
    });
}
